(function(){

	const lazyLoadVideoSections = document.querySelectorAll('[data-adev-lazyload-video]');
	  
	const lazyLoadVideo = (entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const videoSection = entry.target;
				const placeholderImg = videoSection.querySelector("img");
				const videoTemplate = videoSection.querySelector("template");
				
				if (videoTemplate) {
					const videoContent = document.createRange().createContextualFragment(videoTemplate.innerHTML);
					videoSection.replaceChild(videoContent, placeholderImg);

					const video = videoSection.querySelector("video");
					if (video) {
						video.play();
					}

					observer.unobserve(videoSection);
				}
			}
		});
	};
	
	const observer = new IntersectionObserver(lazyLoadVideo, {
		root: null,
		rootMargin: "0px",
		threshold: 0.01
	});
	
	lazyLoadVideoSections.forEach(section => observer.observe(section));

})();


const sliderABTestInit = (isUpdate) => {
	if (
		document.querySelectorAll(".js-media-list-ab-test") &&
		document.querySelectorAll(".js-media-list-ab-test").length > 0
	) {
		document.querySelectorAll(".js-media-list-ab-test").forEach((elem) => {
			const mediaListId = elem.dataset?.jsMediaListId;
			const mediaSublist = Array.from(document.querySelectorAll(".js-media-sublist")).find(
				(subElem) => subElem.dataset?.jsMediaListId === mediaListId && subElem.swiper
			);

			const createSlider = () => {
				if (elem.swiper) return;

				elem.swiper = new Swiper(elem, {
					slidesPerView: 1,
					spaceBetween: 5,
					autoHeight: true,
					speed: 800,
					navigation: {
						nextEl: ".product .product__slider-nav .swiper-button-next",
						prevEl: ".product .product__slider-nav .swiper-button-prev",
					},
					pagination: {
						el: ".product .product__pagination",
						type: "progressbar",
						clickable: true,
					},
					thumbs: {
						swiper: mediaListId && mediaSublist ? mediaSublist.swiper : "",
					},
					on: {
						slideChangeTransitionStart: function () {
							if (mediaListId && mediaSublist) {
								mediaSublist.swiper.slideTo(this.activeIndex);
							}
						},
						slideChange: function () {
							window.pauseAllMedia();
							this.params.noSwiping = false;

							// Sync the popup slider that corresponds to this gallery
							const galleryId = this.el.dataset.jsMediaListId;
							const popup = galleryId
								? document.querySelector(`.js-popup-slider[data-js-media-list-id="${galleryId}"]:not(.hidden)`)
								: (document.querySelector('.js-popup-slider-default:not(.hidden)') || document.querySelector('.js-popup-slider:not(.hidden)'));
							if (popup && popup.swiper) {
								popup.swiper.slideTo(this.activeIndex);
							}
						},
						slideChangeTransitionEnd: function () {
							if (this.slides[this.activeIndex].querySelector("model-viewer")) {
								this.slides[this.activeIndex]
									.querySelector(".shopify-model-viewer-ui__button--poster")
									.removeAttribute("hidden");
							}
						},
						touchStart: function () {
							if (this.slides[this.activeIndex].querySelector("model-viewer")) {
								if (
									!this.slides[this.activeIndex]
										.querySelector("model-viewer")
										.classList.contains("shopify-model-viewer-ui__disabled")
								) {
									this.params.noSwiping = true;
									this.params.noSwipingClass = "swiper-slide";
								} else {
									this.params.noSwiping = false;
								}
							}
						},
					},
				});
			};

			const destroySlider = () => {
				if (!elem.swiper) return;
				elem.swiper.destroy(true, true);
				elem.swiper = null;
			};

			const applyBreakpoint = (isDesktop) => {
				if (isDesktop) destroySlider();
				else createSlider();
			};

			const mql = window.matchMedia("(min-width: 990px)");

			const handler = (e) => {
				e.matches ? destroySlider() : createSlider();
			};

			// Safari fallback
			if (mql.addEventListener) {
				mql.addEventListener("change", handler);
			} else {
				mql.addListener(handler);
			}
			mql.matches ? destroySlider() : createSlider();
		});
	}
};


const initVideoControls = () => {
    const popup = document.getElementById('videoPopup');

    if (!popup) {
        // console.error("Popup element #videoPopup not found!");
        return;
    }

    if (popup.parentNode !== document.body) {
        document.body.appendChild(popup);
    }

    const popupVideo = popup.querySelector('.video-popup-video');
    const popupContent = popup.querySelector('.video-popup-content');
    const closeBtn = popup.querySelector('.video-popup-close');
    const muteBtn = popup.querySelector('.video-popup-mute-toggle');
    const overlay = popup.querySelector('.video-popup-overlay');
    const videoItems = document.querySelectorAll('.product-video-slider-item');

    const applyVideoRatio = () => {
        const w = popupVideo.videoWidth;
        const h = popupVideo.videoHeight;
        if (popupContent && w && h) {
            popupContent.style.setProperty('--popup-w', w);
            popupContent.style.setProperty('--popup-h', h);
        }
    };

    popupVideo.addEventListener('loadedmetadata', applyVideoRatio);

    const openPopup = (src) => {
        if (!src) return;

        popupVideo.src = src;
        popup.classList.add('is-active');
        document.body.classList.add('video-popup-open');

        popupVideo.muted = false;
        popupVideo.play().catch(err => console.warn("Video play blocked:", err));

        updateMuteUI();
    };

    const closePopup = () => {
        popup.classList.remove('is-active');
        document.body.classList.remove('video-popup-open');
        popupVideo.pause();
        popupVideo.src = "";
        if (popupContent) {
            popupContent.style.removeProperty('--popup-w');
            popupContent.style.removeProperty('--popup-h');
        }
    };

    const updateMuteUI = () => {
        if (muteBtn) {
            muteBtn.classList.toggle('is-muted', popupVideo.muted);
        }
    };

    videoItems.forEach(item => {
        const video = item.querySelector('.product-video-slider-video');

        item.addEventListener('click', (e) => {
            e.preventDefault();
            const videoSrc = video.querySelector('source') ? video.querySelector('source').src : video.src;
            openPopup(videoSrc);
        });
    });

    if (muteBtn) {
        muteBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            popupVideo.muted = !popupVideo.muted;
            updateMuteUI();
        });
    }

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoControls);
} else {
    initVideoControls();
}


const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".js-media-list") &&
		document.querySelectorAll(".js-media-list").length > 0
	) {
		document.querySelectorAll(".js-media-list").forEach((elem) => {
			const mediaListId = elem.dataset?.jsMediaListId;
			const mediaSublist = Array.from(document.querySelectorAll(".js-media-sublist")).find((subElem) => subElem.dataset?.jsMediaListId === mediaListId && subElem.swiper);
			let slider = new Swiper(elem, {
				slidesPerView: 1,
				spaceBetween: 1,
				autoHeight: true,
				speed: 800,
				navigation: {
					nextEl: ".product .product__slider-nav .swiper-button-next",
					prevEl: ".product .product__slider-nav .swiper-button-prev",
				},
				pagination: {
					el: ".product .product__pagination",
					type: "bullets",
					clickable: true,
				},
				thumbs: {
					swiper: mediaListId && mediaSublist ? mediaSublist.swiper : "",
				},
				on: {
					slideChangeTransitionStart: function () {
						if (mediaListId && mediaSublist) {
							mediaSublist.swiper.slideTo(this.activeIndex);
						}
					},
					slideChange: function () {
						window.pauseAllMedia();
						this.params.noSwiping = false;

						const defaultPopup = document.querySelector(".js-popup-slider-default:not(.hidden)")
							|| document.querySelector(".js-popup-slider:not(.hidden)");
						if (defaultPopup && defaultPopup.swiper) {
							defaultPopup.swiper.slideTo(this.activeIndex);
						}
					},
					slideChangeTransitionEnd: function () {
						if (this.slides[this.activeIndex].querySelector("model-viewer")) {
							this.slides[this.activeIndex]
								.querySelector(".shopify-model-viewer-ui__button--poster")
								.removeAttribute("hidden");
						}
					},
					touchStart: function () {
						if (this.slides[this.activeIndex].querySelector("model-viewer")) {
							if (
								!this.slides[this.activeIndex]
									.querySelector("model-viewer")
									.classList.contains("shopify-model-viewer-ui__disabled")
							) {
								this.params.noSwiping = true;
								this.params.noSwipingClass = "swiper-slide";
							} else {
								this.params.noSwiping = false;
							}
						}
					},
				},
			});

			if (isUpdate) {
				setTimeout(function () {
					slider.update();
				}, 800);
			}
		});
	}
};

const subSliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".js-media-sublist") &&
		document.querySelectorAll(".js-media-sublist").length > 0
	) {
		document.querySelectorAll(".js-media-sublist").forEach((elem) => {
			let subSlider = new Swiper(elem, {
				slidesPerView: 4,
				spaceBetween: 8,
				direction: "horizontal",
				freeMode: false,
				watchSlidesProgress: true,
				//autoHeight: true,
				on: {
					touchEnd: function (s, e) {
						let range = 5;
						let diff = (s.touches.diff = s.isHorizontal()
							? s.touches.currentX - s.touches.startX
							: s.touches.currentY - s.touches.startY);
						if (diff < range || diff > -range) s.allowClick = true;
					},
				},
				breakpoints: {
					990: {
						spaceBetween: 16,
						direction: "vertical",
						slidesPerView: 4,
					},
				},
			});

			if (isUpdate) {
				setTimeout(function () {
					subSlider.update();
				}, 800);
			}
		});
	}
};

const popupSliderInit = (isUpdate) => {
	const popupInitTarget = document.querySelector(".js-popup-slider-default:not(.hidden)")
		|| document.querySelector(".js-popup-slider:not(.hidden)");
	if (popupInitTarget) {
		let popupSlider = new Swiper(popupInitTarget, {
			slidesPerView: 1,
			navigation: {
				nextEl: ".product-media-modal .product__slider-nav .swiper-button-next",
				prevEl: ".product-media-modal .product__slider-nav .swiper-button-prev",
			},
			pagination: {
				el: ".product-media-modal .product__pagination",
				type: "bullets",
				clickable: true,
			},
			on: {
				afterInit: function () {
					if (document.querySelector(".product__outer--static-column-aside")) {
						document
							.querySelectorAll(".product__media-list .product__media-toggle")
							.forEach((elem, index) => {
								elem.addEventListener("click", (e) => {
									if (document.querySelector(".js-popup-slider") && document.querySelector(".js-popup-slider").swiper) {
										document.querySelector(".js-popup-slider").swiper.slideTo(index);
									}
								});
							});
					}
				},
				slideChange: function () {
					window.pauseAllMedia();
					this.params.noSwiping = false;
					this.el.classList.remove("zoom");
				},
				touchMove: function () {
					this.el.classList.remove("zoom");
				},
				slideChangeTransitionEnd: function () {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						this.slides[this.activeIndex]
							.querySelector(".shopify-model-viewer-ui__button--poster")
							.removeAttribute("hidden");
					}
				},
				touchStart: function () {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						if (
							!this.slides[this.activeIndex]
								.querySelector("model-viewer")
								.classList.contains("shopify-model-viewer-ui__disabled")
						) {
							this.params.noSwiping = true;
							this.params.noSwipingClass = "swiper-slide";
						} else {
							this.params.noSwiping = false;
						}
					}
				},
			},
		});

		if (isUpdate) {
			setTimeout(function () {
				popupSlider.update();
			}, 800);
		}
	}
};

if (navigator.userAgent.indexOf("iPhone") > -1) {
	document
		.querySelector("[name=viewport]")
		.setAttribute(
			"content",
			"width=device-width, initial-scale=1, maximum-scale=1",
		);
}

function getFocusableElements(container) {
	if (!container) return [];
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", "false");

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open"),
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	if (elementToFocus) elementToFocus.focus();
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*",
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus && !elementToFocus.classList.contains("card-focused"))
		elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) => {
			this.setMinimumDisable();

			button.addEventListener("click", this.onButtonClick.bind(this));
		});

		var eventList = ["paste", "input"];

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/;

				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ""
				) {
					e.currentTarget.value;
				} else {
					e.currentTarget.value = 1;
				}

				if (e.currentTarget.value === 1 || e.currentTarget.value === "") {
					this.previousElementSibling.classList.add("disabled");
				} else {
					this.previousElementSibling.classList.remove("disabled");
				}
			});
		}

		this.input.addEventListener("focusout", function (e) {
			if (e.currentTarget.value === "") {
				e.currentTarget.value = 1;
			}
		});
	}

	setMinimumDisable() {
		if (this.input.value == 1) {
			this.querySelector('button[name="minus"]').classList.add("disabled");
		} else {
			this.querySelector('button[name="minus"]').classList.remove("disabled");
		}
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);

		this.setMinimumDisable();
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

const serializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);
	for (const key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options,
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid,
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this),
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (let i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");
		const summaryElements = this.querySelectorAll("summary");
		this.addAccessibilityAttributes(summaryElements);

		this.headerWrapper = document.querySelector(".header-wrapper");
		if (this.headerWrapper) this.headerWrapper.preventHide = false;

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`,
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) =>
			summary.addEventListener("click", this.onSummaryClick.bind(this)),
		);
		this.querySelectorAll("button").forEach((button) => {
			if (this.querySelector(".toggle-scheme-button") === button) return;
			if (this.querySelector(".header__localization-button") === button) return;
			if (this.querySelector(".header__localization-lang-button") === button)
				return;
			button.addEventListener("click", this.onCloseButtonClick.bind(this));
		});
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute("role", "button");
			element.setAttribute("aria-expanded", false);
			element.setAttribute("aria-controls", element.nextElementSibling.id);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute("open");

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement);
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button"),
			);

			setTimeout(() => {
				detailsElement.classList.add("menu-opening");
			});
		}
	}

	openMenuDrawer(summaryElement) {
		if (this.headerWrapper) this.headerWrapper.preventHide = true;
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove("menu-opening");
			this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
				details.removeAttribute("open");
				details.classList.remove("menu-opening");
			});
			this.mainDetailsToggle
				.querySelector("summary")
				.setAttribute("aria-expanded", false);
			document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
			this.header = this.header || document.querySelector(".shopify-section-header");
			const main = document.querySelector("main");
			if (
				main?.querySelectorAll(".shopify-section")[0]?.classList.contains("section--has-overlay") &&
				!this.header.classList.contains("animate")
			) {
				this.header.classList.remove("color-background-overlay-hidden");
				this.header.classList.add("color-background-overlay");
			}

			if (this.headerWrapper) this.headerWrapper.preventHide = false;
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove("menu-opening");
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary"),
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
		this.headerWrapper = document.querySelector('.header-wrapper');
		if (this.headerWrapper) this.headerWrapper.preventHide = false;
	}

	openMenuDrawer(summaryElement) {
		if (this.headerWrapper) this.headerWrapper.preventHide = true;
		this.header = this.header || document.querySelector(".shopify-section-header");
		this.borderOffset =
			this.borderOffset ||
			this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;

		const main = document.querySelector("main");
		if (main?.querySelectorAll(".shopify-section")[0]?.classList.contains("section--has-overlay")) {
			this.header.classList.remove("color-background-overlay");
			this.header.classList.add("color-background-overlay-hidden");
		}


		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this, false),
		);
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", (event) => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide();
			});
		} else {
			this.addEventListener("click", (event) => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden-modal");
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		let isOpen = false;

		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();

		document.querySelectorAll("body > quick-add-modal").forEach((el) => {
			if (el.hasAttribute("open")) {
				isOpen = true;
			}
		});

		if (!isOpen) {
			document.body.classList.remove("overflow-hidden-modal");
			document.body.dispatchEvent(new CustomEvent("modalClosed"));
		}

		const images = document.querySelector(".product-media-modal__content");

		if (images) {
			images.classList.remove("zoom");
		}
	}
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			if (modal) modal.show(button);
		});
	}
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			"click",
			this.loadContent.bind(this),
		);
	}

	loadContent() {
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(
					true,
				),
			);

			this.setAttribute("loaded", true);
			window.pauseAllMedia();
			this.appendChild(
				content.querySelector("video, model-viewer, iframe"),
			).focus();

			if (
				this.closest(".swiper")?.swiper.slides[
					this.closest(".swiper").swiper.activeIndex
				].querySelector("model-viewer")
			) {
				if (
					!this.closest(".swiper")
						.swiper.slides[
							this.closest(".swiper").swiper.activeIndex
						].querySelector("model-viewer")
						.classList.contains("shopify-model-viewer-ui__disabled")
				) {
					this.closest(".swiper").swiper.params.noSwiping = true;
					this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
				}
			}
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

// Backup:

// class VariantSelects extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.addEventListener("change", this.onVariantChange);
// 	}

// 	onVariantChange() {
// 		this.updateOptions();
// 		this.updateMasterId();
// 		this.toggleAddButton(true, "", false);
// 		this.updatePickupAvailability();
// 		this.updateVariantStatuses();

// 		if (!this.currentVariant) {
// 			this.toggleAddButton(true, "", true);
// 			this.setUnavailable();
// 		} else {
// 			if (!this.closest("floated-form")) {
// 				this.updateMedia();
// 			}
// 			this.updateURL();
// 			this.updateVariantInput();
// 			this.renderProductInfo();

// 			document.dispatchEvent(new CustomEvent('adev:variant_changed', {
// 				detail: this.currentVariant
// 			}));
// 		}
// 	}

// 	updateOptions() {
// 		const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

// 		this.options = Array.from(
// 			this.querySelectorAll("select"),
// 			(select) => select.value,
// 		).concat(
// 			fieldsets.map((fieldset) => {
// 				return Array.from(fieldset.querySelectorAll("input")).find(
// 					(radio) => radio.checked,
// 				).value;
// 			}),
// 		);
// 	}

// 	updateMasterId() {
// 		if (this.variantData || this.querySelector('[type="application/json"]')) {
// 			this.currentVariant = this.getVariantData().find((variant) => {
// 				this.options.sort();
// 				variant.options.sort();

// 				return !variant.options
// 					.map((option, index) => {
// 						return this.options[index] === option;
// 					})
// 					.includes(false);
// 			});
// 		}
// 	}

// 	isHidden(elem) {
// 		const styles = window.getComputedStyle(elem);
// 		return styles.display === "none" || styles.visibility === "hidden";
// 	}

// 	updateMedia() {
// 		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

// 		const swiperWrappers = document.querySelectorAll(".product__media-wrapper");

// 		swiperWrappers.forEach((elem) => {
// 			if (!this.isHidden(elem)) {
// 				const newMedia = elem.querySelector(
// 					`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
// 				);

// 				if (elem.querySelector(".js-media-list")) {
// 					elem
// 						.querySelector(".js-media-list")
// 						.swiper.slideTo(
// 						elem
// 							.querySelector(".js-media-list")
// 							.swiper.slides.indexOf(newMedia),
// 					);
// 				}
// 			}
// 		});
// 	}

// 	updateURL() {
// 		if (!this.classList.contains("featured-product-radios")) {
// 			console.log(this.currentVariant);
			
// 			if (!this.currentVariant || this.dataset.updateUrl === "false") return;
// 			window.history.replaceState(
// 				{},
// 				"",
// 				`${this.dataset.url}?variant=${this.currentVariant.id}`,
// 			);
// 		}
// 	}

// 	updateVariantInput() {
// 		const productForms = document.querySelectorAll(
// 			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
// 		);
// 		productForms.forEach((productForm) => {
// 			const input = productForm.querySelector('input[name="id"]');
// 			input.value = this.currentVariant.id;
// 			input.dispatchEvent(new Event("change", { bubbles: true }));
// 		});
// 	}

// 	updateVariantStatuses() {
// 		const selectedOptionOneVariants = this.variantData.filter(
// 			(variant) => this.querySelector(":checked").value === variant.option1,
// 		);
// 		const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
// 		inputWrappers.forEach((option, index) => {
// 			if (index === 0) return;
// 			const optionInputs = [
// 				...option.querySelectorAll('input[type="radio"], option'),
// 			];
// 			const previousOptionSelected =
// 				inputWrappers[index - 1].querySelector(":checked").value;
// 			const availableOptionInputsValue = selectedOptionOneVariants
// 				.filter(
// 					(variant) =>
// 						variant.available &&
// 						variant[`option${index}`] === previousOptionSelected,
// 				)
// 				.map((variantOption) => variantOption[`option${index + 1}`]);
// 			this.setInputAvailability(optionInputs, availableOptionInputsValue);
// 		});
// 	}

// 	setInputAvailability(listOfOptions, listOfAvailableOptions) {
// 		listOfOptions.forEach((input) => {
// 			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
// 				if (input.tagName === "OPTION") {
// 					input.innerText = input.getAttribute("value");
// 				} else if (input.tagName === "INPUT") {
// 					input.classList.remove("disabled");
// 				}
// 			} else {
// 				if (input.tagName === "OPTION") {
// 					input.innerText =
// 						window.variantStrings.unavailable_with_option.replace(
// 							"[value]",
// 							input.getAttribute("value"),
// 						);
// 				} else if (input.tagName === "INPUT") {
// 					input.classList.add("disabled");
// 				}
// 			}
// 		});
// 	}

// 	updatePickupAvailability() {
// 		const pickUpAvailability = document.querySelector("pickup-availability");
// 		if (!pickUpAvailability) return;

// 		if (this.currentVariant && this.currentVariant.available) {
// 			pickUpAvailability.fetchAvailability(this.currentVariant.id);
// 		} else {
// 			pickUpAvailability.removeAttribute("available");
// 			pickUpAvailability.innerHTML = "";
// 		}
// 	}

// 	renderProductInfo() {
// 		const requestedVariantId = this.currentVariant.id;
// 		const sectionId = this.dataset.originalSection
// 			? this.dataset.originalSection
// 			: this.dataset.section;

// 		fetch(
// 			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
// 				this.dataset.originalSection
// 					? this.dataset.originalSection
// 					: this.dataset.section
// 			}`,
// 		)
// 			.then((response) => response.text())
// 			.then((responseText) => {
// 				// prevent unnecessary ui changes from abandoned selections
// 				if (!this.currentVariant) return;
// 				if (this.currentVariant.id !== requestedVariantId) return;

// 				const html = new DOMParser().parseFromString(responseText, "text/html");
// 				const destination = document.getElementById(`price-${this.dataset.section}`,);
// 				const source = html.getElementById(
// 					`price-${
// 						this.dataset.originalSection
// 							? this.dataset.originalSection
// 							: this.dataset.section
// 					}`,
// 				);
// 				const skuSource = html.getElementById(
// 					`Sku-${
// 						this.dataset.originalSection
// 							? this.dataset.originalSection
// 							: this.dataset.section
// 					}`,
// 				);
// 				const skuDestination = document.getElementById(
// 					`Sku-${this.dataset.section}`,
// 				);
// 				const inventorySource = html.getElementById(
// 					`Inventory-${
// 						this.dataset.originalSection
// 							? this.dataset.originalSection
// 							: this.dataset.section
// 					}`,
// 				);
// 				const inventoryDestination = document.getElementById(
// 					`Inventory-${this.dataset.section}`,
// 				);
// 				const colorNameSource = html.getElementById(
// 					`ColorName-${
// 						this.dataset.originalSection
// 							? this.dataset.originalSection
// 							: this.dataset.section
// 					}`,
// 				);
// 				const colorNameDestination = document.getElementById(
// 					`ColorName-${this.dataset.section}`,
// 				);

// 				if (source && destination) destination.innerHTML = source.innerHTML;
// 				if (inventorySource && inventoryDestination)
// 					inventoryDestination.innerHTML = inventorySource.innerHTML;
// 				if (skuSource && skuDestination) {
// 					skuDestination.innerHTML = skuSource.innerHTML;
// 					skuDestination.classList.toggle(
// 						"visibility-hidden",
// 						skuSource.classList.contains("visibility-hidden"),
// 					);
// 				}
// 				if (colorNameSource && colorNameDestination)
// 					colorNameDestination.innerHTML = colorNameSource.innerHTML;

// 				const price = document.getElementById(`price-${this.dataset.section}`);

// 				if (price) price.classList.remove("visibility-hidden");

// 				if (inventoryDestination)
// 					inventoryDestination.classList.toggle(
// 						"visibility-hidden",
// 						inventorySource.innerText === "",
// 					);

// 				this.toggleAddButton(
// 					!this.currentVariant.available,
// 					window.variantStrings.soldOut,
// 				);
// 			});
// 	}

// 	toggleAddButton(disable = true, text, modifyClass = true) {
// 		const productForm = document.getElementById(
// 			`product-form-${this.dataset.section}`,
// 		);
// 		if (!productForm) return;
// 		const addButton = productForm.querySelector('[name="add"]');
// 		const addButtonText = productForm.querySelector('[name="add"] > span');
// 		if (!addButton) return;

// 		if (disable) {
// 			addButton.setAttribute("disabled", "disabled");
// 			if (text) addButtonText.textContent = text;
// 		} else {
// 			addButton.removeAttribute("disabled");
// 			addButtonText.textContent = window.variantStrings.addToCart;
// 		}

// 		if (!modifyClass) return;
// 	}

// 	setUnavailable() {
// 		const button = document.getElementById(
// 			`product-form-${this.dataset.section}`,
// 		);
// 		const addButton = button.querySelector('[name="add"]');
// 		const price = document.getElementById(`price-${this.dataset.section}`);
// 		const inventory = document.getElementById(
// 			`Inventory-${this.dataset.section}`,
// 		);
// 		const sku = document.getElementById(`Sku-${this.dataset.section}`);

// 		if (!addButton) return;
// 		this.toggleAddButton(true, window.variantStrings.unavailable);
// 		if (price) price.classList.add("visibility-hidden");
// 		if (inventory) inventory.classList.add("visibility-hidden");
// 		if (sku) sku.classList.add("visibility-hidden");
// 	}

// 	getVariantData() {
// 		this.variantData =
// 			this.variantData ||
// 			JSON.parse(this.querySelector('[type="application/json"]').textContent);
// 		return this.variantData;
// 	}
// }

// customElements.define("variant-selects", VariantSelects);


class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
		requestAnimationFrame(() => {
			this.updateOptions();
			this.updateMasterId();
			this.updateCustomPairButtonState();
		});
	}

	onVariantChange(event) {
		const form = document.querySelector('.product-form form');
		const changedPairFieldset = event?.target?.closest('fieldset')?.querySelector('[data-custom-pair-button]');
		if (form && form.dataset.customPairActive === 'true' && changedPairFieldset) {
			form.dataset.customPairActive = 'false';
			const pairBtn = document.querySelector('.custom-pair-btn');
			if (pairBtn) {
				pairBtn.classList.remove('is-active');
				pairBtn.setAttribute('aria-pressed', 'false');
			}
		}
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
		this.updateVariantStatuses();
		this.updateCustomPairButtonState();

		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			if (!this.closest("floated-form")) {
				this.updateMedia();
			}
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();

			document.dispatchEvent(new CustomEvent('adev:variant_changed', {
				detail: this.currentVariant
			}));
		}
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

		this.options = Array.from(
			this.querySelectorAll("select"),
			(select) => select.value,
		).concat(
			fieldsets.map((fieldset) => {
				const checked = Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked);
				return checked ? checked.value : null;
			}).filter(Boolean)
		);
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				const sortedOptions = [...this.options].sort();
				const sortedVariantOptions = [...variant.options].sort();

				return !sortedVariantOptions
					.map((option, index) => {
						return sortedOptions[index] === option;
					})
					.includes(false);
			});
		}
	}

	isHidden(elem) {
		return elem.classList.contains("hidden");
	}

	updateMedia() {
		if (this.updateCustomPairMedia()) return;
		if (!this.currentVariant) return;

		const swiperWrappers = document.querySelectorAll(".product__media-wrapper");

		swiperWrappers.forEach((elem) => {
			if (!this.isHidden(elem)) {
				const variantGalleries = elem.querySelectorAll('[data-variant-id]');

				if (variantGalleries.length > 0) {
					variantGalleries.forEach(gallery => {
						if (gallery.dataset.variantId == this.currentVariant.id) {
							gallery.classList.remove('hidden');
							if (gallery.swiper) {
								gallery.swiper.update();
								gallery.swiper.slideTo(0, 0);
							}
						} else {
							gallery.classList.add('hidden');
						}
					});
				}

				if (!this.currentVariant.featured_media) return;

				const newMedia = elem.querySelector(
					`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
				);

				const mediaList = elem.querySelector(".js-media-list");
				if (mediaList && newMedia && mediaList.swiper) {
					mediaList.swiper.slideTo(
						Array.from(mediaList.swiper.slides).indexOf(newMedia)
					);
				}
			}
		});
	}

	updateCustomPairMedia() {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		const isPairActive = productForm?.dataset.customPairActive === 'true';
		const pairButton = this.querySelector('[data-custom-pair-button]');

		if (isPairActive && pairButton?.dataset.pairVariants) {
			const currentOptions = this.currentVariant?.options;
			const sideOptionIndex = this.getPickerSideOptionIndex();
			if (currentOptions && sideOptionIndex >= 0) {
				try {
					const pairVariants = JSON.parse(pairButton.dataset.pairVariants);
					const normalize = (v) => v?.toString().trim().replace(/\s*\/\s*/g, ' / ').replace(/\s+/g, ' ').toLowerCase();
					const pairOptions = [...currentOptions];
					pairOptions[sideOptionIndex] = 'Pair';
					const pairVariantName = normalize(pairOptions.join(' / '));
					const matchingEntry = pairVariants.find((e) => normalize(e.variant_name) === pairVariantName);
					if (matchingEntry) {
						pairButton.dataset.activePairVariantName = matchingEntry.variant_name || '';
					}
				} catch {}
			}
		}

		const activePairVariantName = pairButton?.dataset.activePairVariantName;
		let pairGalleryShown = false;

		document.querySelectorAll(".product__media-wrapper").forEach((elem) => {
			if (this.isHidden(elem)) return;

			const pairGalleries = elem.querySelectorAll('[data-pair-gallery]');
			if (!pairGalleries.length) return;

			if (isPairActive) {
				elem.querySelectorAll('[data-variant-id]').forEach((gallery) => {
					gallery.classList.add('hidden');
				});
			}

			pairGalleries.forEach((gallery) => {
				const isActivePairGallery = isPairActive && (!activePairVariantName || gallery.dataset.pairVariantName === activePairVariantName);
				gallery.classList.toggle('hidden', !isActivePairGallery);
				if (isActivePairGallery) {
					pairGalleryShown = true;
					if (gallery.swiper) {
						gallery.swiper.update();
						gallery.swiper.slideTo(0, 0);
					}
				}
			});
		});

		return isPairActive && pairGalleryShown;
	}

	updateCustomPairPrice() {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		if (productForm?.dataset.customPairActive !== 'true') return;

		const pairButton = this.querySelector('[data-custom-pair-button]');
		if (!pairButton) return;

		const variantData = this.getVariantData();
		const partsMap = this.getVariantPartsMap();
		const currentOptions = this.options?.length ? this.options : this.currentVariant?.options;
		if (!currentOptions) return;

		let sideOptionIndex = this.getPickerSideOptionIndex();
		if (sideOptionIndex < 0 && this.currentVariant) {
			const currentPartType = this.getPartType(partsMap, this.currentVariant.id);
			sideOptionIndex = this.getSideOptionIndex(variantData, partsMap, this.currentVariant, currentPartType);
		}
		if (sideOptionIndex < 0) return;

		const findVariantForPrice = (partType) =>
			this.findPairVariant(variantData, partsMap, currentOptions, sideOptionIndex, partType) ||
			variantData.find((v) =>
				this.getPartType(partsMap, v.id) === partType &&
				v.options.every((o, i) => i === sideOptionIndex || o === currentOptions[i])
			);

		const leftV = findVariantForPrice('left');
		const rightV = findVariantForPrice('right');

		let computedPrice = pairButton.dataset.activePairPrice || '';
		if (leftV && rightV) {
			const totalCents = (leftV.price || 0) + (rightV.price || 0);
			const discountPct = window.theme?.pairDiscount?.percentage || 0;
			const discountedCents = Math.round(totalCents * (1 - discountPct / 100));
			const moneyFormat = window.theme?.moneyFormat || '${{amount}}';
			computedPrice = moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, (discountedCents / 100).toFixed(2));
			pairButton.dataset.activePairPrice = computedPrice;
		}

		if (!computedPrice) return;

		const priceWrapper = document.getElementById(`price-${this.dataset.section}`);
		priceWrapper?.querySelector('.price')?.classList.remove('price--on-sale', 'price--sold-out');
		priceWrapper?.querySelectorAll('.price__regular .price-item, .price__sale .price-item--sale').forEach((priceEl) => {
			priceEl.innerHTML = computedPrice;
		});
		if (priceWrapper) priceWrapper.classList.remove("visibility-hidden");
	}

	updateURL() {
		if (!this.classList.contains("featured-product-radios")) {
			if (!this.currentVariant || this.dataset.updateUrl === "false") return;
			window.history.replaceState(
				{},
				"",
				`${this.dataset.url}?variant=${this.currentVariant.id}`,
			);
		}
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOne = this.options?.[0] || this.currentVariant?.option1;
		if (!selectedOptionOne) return;

		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => selectedOptionOne === variant.option1,
		);
		const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			];
			const previousOptionSelected =
				inputWrappers[index - 1].querySelector(":checked")?.value || this.options?.[index - 1] || this.currentVariant?.[`option${index}`];
			if (!previousOptionSelected) return;

			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant[`option${index}`] === previousOptionSelected,
				)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				if (input.tagName === "OPTION") {
					input.innerText = input.getAttribute("value");
				} else if (input.tagName === "INPUT") {
					input.classList.remove("disabled");
				}
			} else {
				if (input.tagName === "OPTION") {
					input.innerText =
						window.variantStrings.unavailable_with_option.replace(
							"[value]",
							input.getAttribute("value"),
						);
				} else if (input.tagName === "INPUT") {
					input.classList.add("disabled");
				}
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section;

		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`,
		)
			.then((response) => response.text())
			.then((responseText) => {
				if (!this.currentVariant) return;
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, "text/html");
				const destination = document.getElementById(`price-${this.dataset.section}`,);
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`,
				);
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`,
				);
				const skuDestination = document.getElementById(
					`Sku-${this.dataset.section}`,
				);
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`,
				);
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`,
				);

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle(
						"visibility-hidden",
						skuSource.classList.contains("visibility-hidden"),
					);
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove("visibility-hidden");

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						"visibility-hidden",
						inventorySource.innerText === "",
					);

				this.toggleAddButton(
					!this.currentVariant.available,
					window.variantStrings.soldOut,
				);
				this.updateCustomPairButtonState();
			});
	}

	getVariantPartsMap() {
		const partsMapEl = this.closest('.product-parameters')?.querySelector('[data-variant-parts]');
		if (!partsMapEl) return {};

		try {
			return JSON.parse(partsMapEl.textContent);
		} catch (error) {
			console.error("Error parsing JSON metafields", error);
			return {};
		}
	}

	getPartType(partsMap, variantId) {
		return partsMap[variantId]?.toString().toLowerCase();
	}

	getSideOptionIndex(variantData, partsMap, currentVariant, partType) {
		const directSideIndex = currentVariant.options.findIndex((option) => {
			const normalizedOption = option?.toString().toLowerCase();
			return normalizedOption === 'left' || normalizedOption === 'right' || normalizedOption === 'pair';
		});

		if (directSideIndex >= 0) return directSideIndex;

		const currentPartType = partType || this.getPartType(partsMap, currentVariant.id);
		const oppositePartType = currentPartType === 'left' ? 'right' : 'left';

		const sibling = variantData.find((variant) => {
			if (this.getPartType(partsMap, variant.id) !== oppositePartType) return false;

			const mismatchIndexes = currentVariant.options.reduce((indexes, option, index) => {
				if (variant.options[index] !== option) indexes.push(index);
				return indexes;
			}, []);

			return mismatchIndexes.length === 1;
		});

		if (!sibling) return -1;

		return currentVariant.options.findIndex((option, index) => sibling.options[index] !== option);
	}

	findPairVariant(variantData, partsMap, currentOptions, sideOptionIndex, targetPartType) {
		return variantData.find((variant) => {
			if (!variant.available) return false;
			if (this.getPartType(partsMap, variant.id) !== targetPartType) return false;

			return variant.options.every((option, index) => {
				return index === sideOptionIndex || option === currentOptions[index];
			});
		});
	}

	getPickerSideOptionIndex() {
		return Array.from(this.querySelectorAll('fieldset')).findIndex((fieldset) => {
			return fieldset.querySelector('[data-custom-pair-button]');
		});
	}

	getPairAvailability() {
		const variantData = this.getVariantData();
		const partsMap = this.getVariantPartsMap();
		const currentOptions = this.options?.length ? this.options : this.currentVariant?.options;
		if (!currentOptions) return false;

		let sideOptionIndex = this.getPickerSideOptionIndex();
		if (sideOptionIndex < 0 && this.currentVariant) {
			const currentPartType = this.getPartType(partsMap, this.currentVariant.id);
			sideOptionIndex = this.getSideOptionIndex(variantData, partsMap, this.currentVariant, currentPartType);
		}

		if (sideOptionIndex < 0) return false;

		const leftV = this.findPairVariant(variantData, partsMap, currentOptions, sideOptionIndex, 'left');
		const rightV = this.findPairVariant(variantData, partsMap, currentOptions, sideOptionIndex, 'right');

		return Boolean(leftV && rightV);
	}

	updateCustomPairButtonState() {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		const pairButton = this.querySelector('[data-custom-pair-button]');
		if (!productForm || !pairButton) return;

		const isPairAvailable = this.getPairAvailability();
		const isPairActive = productForm.dataset.customPairActive === 'true';
		const addButton = productForm.querySelector('[name="add"]');

		pairButton.removeAttribute('disabled');
		pairButton.setAttribute('aria-disabled', 'false');
		pairButton.classList.remove('disabled');
		pairButton.classList.toggle('is-active', isPairActive && isPairAvailable);
		pairButton.classList.toggle('is-unavailable', isPairActive && !isPairAvailable);
		pairButton.setAttribute('aria-pressed', isPairActive && isPairAvailable ? 'true' : 'false');

		if (!isPairActive || !addButton) return;

		this.updateCustomPairMedia();
		this.updateCustomPairPrice();

		if (isPairAvailable) {
			this.toggleAddButton(false);
		} else {
			this.toggleAddButton(true, window.variantStrings?.unavailable || "Unavailable");
		}
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute("disabled", "disabled");
			addButton.setAttribute("aria-disabled", "true");
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute("disabled");
			addButton.removeAttribute("aria-disabled");
			addButtonText.textContent = window.variantStrings?.addToCart || "Add to cart";
		}
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		const addButton = button.querySelector('[name="add"]');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`,
		);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);

		if (!addButton) return;
		this.toggleAddButton(true, window.variantStrings?.unavailable || "Unavailable");
		if (price) price.classList.add("visibility-hidden");
		if (inventory) inventory.classList.add("visibility-hidden");
		if (sku) sku.classList.add("visibility-hidden");
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define("variant-selects", VariantSelects);


class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.classList.remove("disabled");
			} else {
				input.classList.add("disabled");
			}
		});
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		const currentOptions = this.currentVariant?.options || [];
		this.options = fieldsets.map((fieldset, index) => {
			const checked = Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked,
			);
			return checked ? checked.value : currentOptions[index];
		});
	}
}

customElements.define("variant-radios", VariantRadios);

class PasswordViewer {
	constructor() {
		const passwordField = document.querySelectorAll(".field--pass");

		passwordField.forEach((el) => {
			const input = el.querySelector("input");
			const btnWrapper = el.querySelector(".button-pass-visibility");
			const btnOpen = el.querySelector(".icon-eye-close");
			const btnClose = el.querySelector(".icon-eye");

			input.addEventListener("input", () => {
				input.value !== ""
					? (btnWrapper.style.display = "block")
					: (btnWrapper.style.display = "none");
			});

			btnOpen.addEventListener("click", () => {
				input.type = "text";
				btnOpen.style.display = "none";
				btnClose.style.display = "block";
			});

			btnClose.addEventListener("click", () => {
				input.type = "password";
				btnOpen.style.display = "block";
				btnClose.style.display = "none";
			});
		});
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			if (this.querySelector('.product-recommendations__loading')) {
				this.querySelector('.product-recommendations__loading').classList.add('loading');
				this.querySelector('.product-recommendations__loading').style.display = 'flex';
			}

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}

					if (this.querySelector('.product-recommendations__empty')) {
						this.querySelector('.product-recommendations__empty').style.display = 'flex';
					}

					/* Color swatches */
					const generateSrcset = (image, widths = []) => {
						const imageUrl = new URL(image['src']);
						return widths
							.filter((width) => width <= image['width'])
							.map((width) => {
								imageUrl.searchParams.set('width', width.toString());
								return `${imageUrl.href} ${width}w`;
							})
							.join(', ');
					};

					const createImageElement = (
						image,
						classes,
						sizes,
						productTitle
					) => {
						const previewImage = image['preview_image'];
						const newImage = new Image(previewImage['width'], previewImage['height']);
						newImage.className = classes;
						newImage.alt = image['alt'] || productTitle;
						newImage.sizes = sizes;
						newImage.src = previewImage['src'];
						newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
						newImage.loading = 'lazy';
						return newImage;
					};

					const checkSwatches = () => {
						document
							.querySelectorAll('.js-color-swatches-wrapper')
							.forEach((wrapper) => {
								wrapper
									.querySelectorAll('.js-color-swatches input')
									.forEach((input) => {
										input.addEventListener('click', (event) => {
											const primaryImage = wrapper.querySelector('.media--first');
											const secondaryImage = wrapper.querySelector('.media--second');
											const handleProduct = wrapper.dataset.product;

											if (event.currentTarget.checked && primaryImage) {
												wrapper
													.querySelector('.js-color-swatches-link')
													.setAttribute('href', event.currentTarget.dataset.variantLink);
												if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
													wrapper
														.querySelector('.card__add-to-cart button[name="add"]')
														.setAttribute("aria-disabled", false);
													if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
														wrapper
															.querySelector('.card__add-to-cart button[name="add"] > span')
															.classList.remove("hidden");
														wrapper
															.querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
															.classList.add("hidden");
													}
													wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
														event.currentTarget.dataset.variantId;
												}
												const currentColor = event.currentTarget.value;

												fetch(window.Shopify.routes.root + `products/${handleProduct}.js`)
													.then(r => r.json())
													.then(function (product) {
														const variant = product.variants.filter(
															(item) =>
																item.featured_media != null &&
																item.options.includes(currentColor)
														)[0];

														if (variant) {
															const newPrimaryImage = createImageElement(
																variant['featured_media'],
																primaryImage.className,
																primaryImage.sizes,
																product.title
															);

															if (newPrimaryImage.src !== primaryImage.src) {
																let flag = false;
																if (secondaryImage) {
																	const secondaryImagePathname = new URL(
																		secondaryImage.src
																	).pathname;
																	const newPrimaryImagePathname = new URL(
																		newPrimaryImage.src
																	).pathname;

																	if (secondaryImagePathname == newPrimaryImagePathname) {
																		primaryImage.remove();
																		secondaryImage.classList.remove('media--second');
																		secondaryImage.classList.add('media--first');
																		flag = true;
																	}
																}
																if (flag == false) {
																	primaryImage.animate(
																		{ opacity: [1, 0] },
																		{
																			duration: 200,
																			easing: 'ease-in',
																			fill: 'forwards',
																		}
																	).finished;
																	setTimeout(function () {
																		primaryImage.replaceWith(newPrimaryImage);
																		newPrimaryImage.animate(
																			{ opacity: [0, 1] },
																			{ duration: 200, easing: 'ease-in' }
																		);
																		if (secondaryImage) {
																			secondaryImage.remove();
																		}
																	}, 200);
																}
															}
														}
													}
												);
											}
										});
									});
							});
					};

					checkSwatches();

					const addClasses = (slider) => {
						const sliderWrapper = slider.querySelector(".product-recommendations__wrapper");
						const slides = slider.querySelectorAll(".product-recommendations__item");

						slider.classList.add("swiper");
						if (sliderWrapper) sliderWrapper.classList.add("swiper-wrapper");

						if (slides.length > 1) {
							slides.forEach((slide) => {
								slide.classList.add("swiper-slide");
							});
						}
					};

					const removeClasses = (slider) => {
						const sliderWrapper = slider.querySelector(".product-recommendations__wrapper");
						const slides = slider.querySelectorAll(".product-recommendations__item");

						slider.classList.remove("swiper");
						if (sliderWrapper) sliderWrapper.classList.remove("swiper-wrapper");

						if (slides.length > 0) {
							slides.forEach((slide) => {
								slide.removeAttribute("style");
								slide.classList.remove("swiper-slide");
							});
						}
					};

					const initSlider = () => {
						const slider = this.querySelector(".swiper--recomend-products");

						if (slider) {
							addClasses(slider);
							const numberColumns = slider.dataset.columnsMobile || 1;

							new Swiper(slider, {
								loop: false,
								speed: 800,
								breakpoints: {
									320: {
										slidesPerView: Number(numberColumns),
										slidesPerGroup: Number(numberColumns),
										spaceBetween: 8,
									},
									750: {
										slidesPerView: 2,
										slidesPerGroup: 2,
										spaceBetween: 16,
									},
								},
								pagination: {
									el: slider.querySelector(".product-recommendations__pagination"),
									clickable: true,
									type: "custom",
									renderCustom: function (swiper, current, total) {
										let out = "";
										for (let i = 1; i < total + 1; i++) {
											if (i == current) {
												out = `${out}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
											} else {
												out = `${out}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
											}
										}
										return out;
									},
								},
							});
						}
					};

					const destroySlider = () => {
						const slider = this.querySelector('.swiper--recomend-products');

						if (slider) {
							removeClasses(slider);
						}
					};

					const initSection = () => {
						const resizeObserver = new ResizeObserver((entries) => {
							const [entry] = entries;

							if (entry.contentRect.width < 990) {
								initSlider();
							} else {
								destroySlider();
							}
						});

						resizeObserver.observe(this);
					};

					initSection();
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					if (this.querySelector('.product-recommendations__loading')) {
						this.querySelector('.product-recommendations__loading').classList.remove('loading');
						this.querySelector('.product-recommendations__loading').remove();
					}
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 200px 0px',
		}).observe(this);
	}
}

customElements.define('product-recommendations', ProductRecommendations);

class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
			button: this.querySelector('button'),
			panel: this.querySelector('ul'),
		};
		this.elements.button.addEventListener('click', this.openSelector.bind(this));
		this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

		this.querySelectorAll('a').forEach((item) =>
			item.addEventListener('click', this.onItemClick.bind(this))
		);
	}

	hidePanel() {
		this.elements.button.setAttribute('aria-expanded', 'false');
		this.elements.panel.setAttribute('hidden', true);
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		this.hidePanel();
		this.elements.button.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		this.elements.input.value = event.currentTarget.dataset.value;
		this.querySelector('form')?.submit();
	}

	openSelector() {
		this.elements.button.focus();
		this.elements.panel.toggleAttribute('hidden');
		this.elements.button.setAttribute(
			'aria-expanded',
			(this.elements.button.getAttribute('aria-expanded') === 'false').toString()
		);
	}

	closeSelector(event) {
		if (!this.contains(event.relatedTarget)) {
			this.hidePanel()
		}
	}
}

customElements.define('localization-form', LocalizationForm);

(function () {
	const initHeaderOverlay = () => {
		const main = document.getElementById("MainContent");
		const sections = main.querySelectorAll(".shopify-section");

		if (sections.length > 0) {
			const sectionFirstChild = sections[0].querySelector("[data-header-overlay]");
			const headerGroupSections = document.querySelectorAll(".shopify-section-group-header-group");
			const header = document.querySelector(".shopify-section-header");
			const breadcrumbs = document.querySelector('body > .breadcrumbs-wrapper');

			if (sectionFirstChild) {
				if (headerGroupSections[headerGroupSections.length - 1] === header) {
					sections[0].classList.add('section--has-overlay');
					header.classList.add('color-background-overlay');
					if (breadcrumbs) breadcrumbs.classList.add('color-background-3');
				} else {
					sections[0].classList.remove('section--has-overlay');
					header.classList.remove('color-background-overlay');
					if (breadcrumbs) breadcrumbs.classList.remove('color-background-3');
				}
			} else {
				sections[0].classList.remove('section--has-overlay');
				header.classList.remove('color-background-overlay');
				if (breadcrumbs) breadcrumbs.classList.remove('color-background-3');
			}
		}
	};

	initHeaderOverlay();

	document.addEventListener("shopify:section:load", initHeaderOverlay);
	document.addEventListener("shopify:section:unload", initHeaderOverlay);
	document.addEventListener("shopify:section:reorder", initHeaderOverlay);
})();

// Global "Add to Cart" button click interceptor
document.addEventListener('click', function(e) {
	const addToCartBtn = e.target.closest('[name="add"], .product-form__submit');

	if (addToCartBtn) {
		const productFormElement = addToCartBtn.closest('product-form');
		if (!productFormElement) return;

		const form = productFormElement.querySelector('form');
		if (!form) return;

		const variantInput = form.querySelector('[name="id"]');
		const currentVariantId = variantInput ? variantInput.value : null;

		if (!currentVariantId) return;

		const formId = form.getAttribute('id') || '';
		const sectionId = formId.replace('product-form-', '');
		const picker = document.getElementById(`variant-radios-${sectionId}`) || document.getElementById(`variant-selects-${sectionId}`);

		const partsMapEl = picker ? picker.closest('.product-parameters')?.querySelector('[data-variant-parts]') : document.querySelector('[data-variant-parts]');
		const partsMap = partsMapEl ? JSON.parse(partsMapEl.textContent) : {};

		let partType = partsMap[currentVariantId];

		if (form.dataset.customPairActive === 'true') {
			partType = 'pair';
		}

		const isPairSelected = partType === 'pair';
		const isHalf = partType === 'left' || partType === 'right';

		if (isPairSelected || isHalf) {
			e.preventDefault();
			e.stopImmediatePropagation();

			if (picker && !picker.currentVariant) {
				const variantData = picker.variantData || JSON.parse(picker.querySelector('[type="application/json"]').textContent);
				picker.currentVariant = variantData.find(v => v.id.toString() === currentVariantId.toString());
			}

			if (isPairSelected && typeof productFormElement.handlePairAdd === 'function') {
				productFormElement.handlePairAdd(picker, partsMap, partType);
			} else if (isHalf && typeof productFormElement.onSubmitHandler === 'function') {
				productFormElement.customPartsData = { map: partsMap, type: partType };
				productFormElement.onSubmitHandler(new Event('submit'));
			}
		}
	}
}, true);
